<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--500" no-body>

                    <div class="card-header">

                    <h2 class=" text-center">
                        Scan To 
                        <b>{{ title }}</b>
                    </h2>
                    <base-button @click="print" class="float-right" type="primary" icon="fa fa-print fa-2x"></base-button>
                    </div>

                    <div class="p-4">
                        <!-- <div class="row justify-content-center mt--300">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/theme/team-4-800x800.jpg'" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                         
                        </div> -->
                        <div class="text-center" id="qrcode">
                            
                           <vue-qr :margin=0 color="#8965e0" :logoCornerRadius="2" logoSrc="/img/little.png" :text="timestamp" :size="400"></vue-qr>
                           
                        </div>
                        <div class="mt-3 py-5 text-center">
                             <h3 class="card-title mb-3">Champions Present 💪🏾</h3>
                            <div class="row justify-content-center mt-2">
                               
                                <div class="col-lg-11">
                                    
                                   <CarouselCard :interval="7000" height="600px" type="card" arrow="always" indicator-position="none">
                                    <CarouselCardItem v-for="(att, index) in attendance" :key="att[0].RowID">
                                        
                                        <b-card
                                            :title="att[0]['rider.FullName']"
                                            :img-src="att[0]['rider.ProfilePicture'] ? att[0]['rider.ProfilePicture'] : '/img/face.png'"
                                            img-alt="Image"
                                            img-top
                                            tag="article"
                                            style="max-width: 20rem;"
                                            class="mb-2"
                                            ref="card"
                                        >
                                            <!-- <lottie-animation
                                                    
                                                    path="winner.json"
                                                    :width="80"
                                                    :height="80"
                                                /> -->
                                            <b> Tasks Complete {{ attendance[index].length }} of {{ tasks.length}}</b>
                                            <p v-for="task in attendance[index]" :key="task.UniqueID">    
                                               {{ task["StaffTask.TaskName"]}} @ {{ moment.utc(task.TrxDate).format("hh:mm a") }}
                                            </p>
                                            <b-card-text>
                                                <icon name="ni ni-square-pin" type="primary" rounded class="mb-4">
                                                </icon>
                                                {{att[0].LocationName}}
                                            </b-card-text>

                                          
                                        </b-card>

                                    </CarouselCardItem>
                                    </CarouselCard>
                                </div>
                                <br>
                                <div class="col-lg-11">
                                    <table class="table table table-responsive">
                                    <thead>
                                        <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Champion</th>
                                        <th scope="col">Task</th>
                                        <th scope="col">Time</th>
                                        <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody  v-for="(item,key) in list" :key="key">
                                   
                                             
                                            <tr v-for="(staff,index) in list[key]" :key="staff.UniqueID" :class="timediff(staff) > 0 && timediff(staff) < 20 ? 'table-primary' :timediff(staff) >= 20 ? 'table-danger' :'table-success' " >
                                                <th scope="row">
                                                    <lottie-animation
                                                            v-if="index+1 ==  list[key].length"
                                                            path="winner.json"
                                                            :width="50"
                                                            :height="50"
                                                    />
                                                    {{ `${list[key].length - index}${nth(list[key].length - index)}` }}
                                                    

                                                </th>
                                                <td>{{ staff["rider.FullName"]}}</td>
                                                <td>{{ staff["StaffTask.TaskName"]}}</td>
                                                <td>{{ moment(staff.TrxDate).subtract(3,'hours').format("MMM Do LT")}}</td>
                                                <td>{{ `${humanizeDuration(moment.duration(Math.abs(timediff(staff)), 'minutes').asMilliseconds())} ${timediff(staff) > 0 && staff["StaffTask.Direction"] == "IN" ? `late ${getEmoji(staff,'late')}`:`early${getEmoji(staff,'early')}`}` }}</td>
                                                
                                            </tr>
                                            <td colspan="5" :key="key" class="text-italic font-weight-bold text-uppercase text-monospace"> ================== {{key}} ==================</td>
                                       
                                  
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; 
import { CarouselCard, CarouselCardItem } from 'vue-carousel-card'
import 'vue-carousel-card/styles/index.css'
import moment from "moment"
import _ from "lodash"
import humanizeDuration  from 'humanize-duration'

export default {
    components: { 
        CarouselCard, 
        CarouselCardItem,
        VueQr, 
        LottieAnimation
    },
    data(){
        return{
            attendance:_.groupBy(this.$store.state.attendance, 'rider.MobileNumber'),
            timestamp:'',
            list:_.groupBy(this.$store.state.attendance, 'StaffTask.TaskName'),
            title:'',
            tasks:this.$store.state.tasks,

        }
    },
    created() {
        this.getTitle()         
        this.getNow()
    },
    mounted(){

            // Object.keys(this.list).map((key, index) => {
            //     this.list[key] = this.list[key].reverse()
            // });

            setInterval(() => {
            this.getNow()
            this.$store.dispatch("getAttendance").then(() => { 

                if(this.attendance.length !== this.$store.state.attendance.length){

                    this.attendance = _.groupBy(this.$store.state.attendance, 'rider.MobileNumber')
                    this.list = _.groupBy(this.$store.state.attendance, 'StaffTask.TaskName')
                    Object.keys(this.list).map((key, index) => {
                        this.list[key] = this.list[key].reverse()
                    });
                }
            })
        }, 8000);
        
    },
    computed:{
        moment(){
              return moment
        },
        humanizeDuration(){
              return humanizeDuration
        },
       
        
        
    },
    methods:{

        getNow(){  
            this.getTitle()       
            fetch(`https://stats.little.bz/attendance/qr/${this.$store.state.user["corporateadmin.CorporateID"]}`, 
                    {
                        method:'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':this.$store.state.token
                        },
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                        
                            if(data.success){
                                this.timestamp = data.str
                            }      
                    })
                    .catch((error) => console.log(error))
              
        },
        getTitle(){
              
              let time = moment().toObject().hours
               
              if  (time < 12 ){
                  this.title = "CLOCK IN ⏰"
              }else if(time >= 12 && time < 14){
                  this.title = "GO FOR LUNCH 🍛🍟🥑"
              }else if(time >= 14 && time < 15){
                  this.title = "CLOCK BACK IN FROM LUNCH 🚶🏻‍♂️"
              }else{
                  this.title = "CLOCK OUT 💃🏽"
              }
        },
        getEmoji(staff,status){

            if(status === "early" && staff["StaffTask.Direction"] == "IN" || status === "late" && staff["StaffTask.Direction"] == "OUT"  ){
                return " 😇"
            }


            if(status === "late" && staff["StaffTask.Direction"] == "IN" || status === "early" && staff["StaffTask.Direction"] == "OUT" ){
                return " 😡"
            }

            // if(status === "late" && moment(staff["StaffTask.RecommendedTime"]).format("HH:mm") > moment("18:00").format("HH:mm")){
            //     return " 😇"
            // } 

            // if(status === "late" && moment(staff["StaffTask.RecommendedTime"]).format("HH:mm") <= moment("18:00").format("HH:mm")){
            //     return " 😡"
            // } 
            
            
            
            
        },
        timediff(staff){
            return moment(staff.TrxDate).subtract(3,'hours').diff(moment(`${moment().format('YYYY-MM-DD')} ${staff["StaffTask.RecommendedTime"]}`), 'minutes')
        },
        nth(n){
            return["st","nd","rd"][((n+90)%100-10)%10-1]||"th"
        },
        print () {
        // Pass the element id here

         var divContents = document.getElementById("qrcode").innerHTML;
            var a = window.open('', '', 'height=1000, width=1000');
            a.document.write('<html>');
            a.document.write('<body>');
            a.document.write(divContents);
            a.document.write('</body></html>');
            a.document.close();
            a.print();
    
        }
    }
};
</script>
<style>

</style>
